import { InventoryItem } from '../../../resources/types';
import type { SeasonPassConfig } from '../../../../gameEvents/seasonPass/types';
import { MS_IN_DAY } from '../../../../utils/time-utils';
import { TimeLimitType } from '../../../../libs/timeLimit/types';

export const hs774lessGenerousConfig: SeasonPassConfig = {
  id: 'hs774lessGenerous',
  minLevelIndex: 8,
  time: {
    type: TimeLimitType.FixedDates,
    startDate: 1763510400000,
    cutOffPoint: MS_IN_DAY * 5,
    endDate: 1765929600000,
  },
  tiers: [
    {
      tokensReq: 0,
      rewardsFree: { [InventoryItem.UnlimitedLivesMinutes]: 60 },
      rewardsPremium: { [InventoryItem.Coin]: 2000 },
    },
    {
      tokensReq: 1,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: { [InventoryItem.BoosterHammer]: 1 },
    },
    {
      tokensReq: 2,
      rewardsFree: { [InventoryItem.BoosterRedraw]: 1 },
      rewardsPremium: { [InventoryItem.Coin]: 500 },
    },
    {
      tokensReq: 3,
      rewardsFree: { [InventoryItem.Coin]: 25, [InventoryItem.Lives]: 1 },
      rewardsPremium: { [InventoryItem.UnlimitedLivesMinutes]: 180 },
    },
    {
      tokensReq: 4,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: { [InventoryItem.Coin]: 250, [InventoryItem.Lives]: 1 },
    },
    {
      tokensReq: 5,
      rewardsFree: { [InventoryItem.Lives]: 1 },
      rewardsPremium: { [InventoryItem.BoosterRedraw]: 1 },
    },
    {
      tokensReq: 10,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: { [InventoryItem.Coin]: 500 },
    },
    {
      tokensReq: 10,
      rewardsFree: { [InventoryItem.UnlimitedLivesMinutes]: 30 },
      rewardsPremium: { [InventoryItem.UnlimitedLivesMinutes]: 180 },
    },
    {
      tokensReq: 10,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: { [InventoryItem.Coin]: 250, [InventoryItem.Lives]: 1 },
    },
    {
      tokensReq: 10,
      rewardsFree: { [InventoryItem.Lives]: 1 },
      rewardsPremium: { [InventoryItem.BoosterMove]: 1 },
    },
    {
      tokensReq: 10,
      rewardsFree: { [InventoryItem.UnlimitedLivesMinutes]: 30 },
      rewardsPremium: { [InventoryItem.Coin]: 500 },
    },
    {
      tokensReq: 15,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: { [InventoryItem.UnlimitedLivesMinutes]: 180 },
    },
    {
      tokensReq: 15,
      rewardsFree: { [InventoryItem.BoosterHammer]: 1 },
      rewardsPremium: { [InventoryItem.Coin]: 250, [InventoryItem.Lives]: 2 },
    },
    {
      tokensReq: 15,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: { [InventoryItem.Coin]: 500 },
    },
    {
      tokensReq: 15,
      rewardsFree: { [InventoryItem.Coin]: 25, [InventoryItem.Lives]: 1 },
      rewardsPremium: { [InventoryItem.BoosterRedraw]: 1 },
    },
    {
      tokensReq: 15,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: { [InventoryItem.Coin]: 250, [InventoryItem.UnlimitedLivesMinutes]: 180 },
    },
    {
      tokensReq: 20,
      rewardsFree: { [InventoryItem.UnlimitedLivesMinutes]: 60 },
      rewardsPremium: { [InventoryItem.Coin]: 500 },
    },
    {
      tokensReq: 20,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: { [InventoryItem.BoosterUndo]: 1 },
    },
    {
      tokensReq: 20,
      rewardsFree: { [InventoryItem.Lives]: 2 },
      rewardsPremium: {
        [InventoryItem.Coin]: 250,
        [InventoryItem.Lives]: 2,
      },
    },
    {
      tokensReq: 20,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: { [InventoryItem.Coin]: 500 },
    },
    {
      tokensReq: 20,
      rewardsFree: { [InventoryItem.UnlimitedLivesMinutes]: 120 },
      rewardsPremium: { [InventoryItem.UnlimitedLivesMinutes]: 360 },
    },
    {
      tokensReq: 25,
      rewardsFree: { [InventoryItem.BoosterMove]: 1 },
      rewardsPremium: { [InventoryItem.Coin]: 750 },
    },
    {
      tokensReq: 25,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: {
        [InventoryItem.Coin]: 250,
        [InventoryItem.Lives]: 4,
      },
    },
    {
      tokensReq: 25,
      rewardsFree: { [InventoryItem.Coin]: 50, [InventoryItem.Lives]: 2 },
      rewardsPremium: { [InventoryItem.BoosterRedraw]: 1 },
    },
    {
      tokensReq: 25,
      rewardsFree: { [InventoryItem.UnlimitedLivesMinutes]: 120 },
      rewardsPremium: { [InventoryItem.Coin]: 750 },
    },
    {
      tokensReq: 25,
      rewardsFree: { [InventoryItem.Coin]: 50 },
      rewardsPremium: {
        [InventoryItem.Coin]: 250,
        [InventoryItem.UnlimitedLivesMinutes]: 720,
      },
    },
    {
      tokensReq: 30,
      rewardsFree: { [InventoryItem.Lives]: 3 },
      rewardsPremium: { [InventoryItem.BoosterMove]: 1 },
    },
    {
      tokensReq: 30,
      rewardsFree: { [InventoryItem.Coin]: 100 },
      rewardsPremium: { [InventoryItem.Coin]: 750 },
    },
    {
      tokensReq: 30,
      rewardsFree: { [InventoryItem.UnlimitedLivesMinutes]: 120 },
      rewardsPremium: { [InventoryItem.BoosterHammer]: 1 },
    },
    {
      tokensReq: 35,
      rewardsFree: {
        [InventoryItem.BoosterUndo]: 1,
        [InventoryItem.Coin]: 250,
      },
      rewardsPremium: {
        [InventoryItem.BoosterUndo]: 1,
        [InventoryItem.Coin]: 1000,
      },
    },
  ],
  vault: { coinIncrease: 100, tokensToIncrease: 20 },
};
